import './contact.css';
import facebookIcon from '../../assets/facebook-icon.png';
import LinkedInIcon from '../../assets/LinkedIn.png';
import githubIcon from '../../assets/github.png';
import instagramIcon from '../../assets/instagram.png';
import React, { useState } from 'react';

const Contact = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    // Handle input change
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage(null);
        setErrorMessage(null);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/contact/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                }
            );

            // Safely parse JSON
            let data = {};
            try {
                data = await response.json();
            } catch {
                data = {};
            }

            if (response.ok) {
                setResponseMessage(
                    data.success || "Message sent successfully!"
                );
                setFormData({
                    name: '',
                    email: '',
                    message: ''
                });
            } else {
                setErrorMessage(
                    data.error ||
                    "Failed to send message. Please try again."
                );
            }

        } catch (error) {
            console.error("Error:", error);
            setErrorMessage("Server connection failed.");
        }

        setLoading(false);
    };

    return (
        <div id='contactPage'>
            <div id="contact">
                <h1 className="contactPageTitle">Contact Me</h1>
                <span className="contactDesc">
                    Please fill out the form below to contact me.
                </span>

                <form className="contactForm" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        className="name"
                        placeholder="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="email"
                        className="email"
                        placeholder="Your Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <textarea
                        name="message"
                        placeholder="Your Message"
                        rows={5}
                        className="msg"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />

                    <button
                        type="submit"
                        className="submitBtn"
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Submit"}
                    </button>

                    {responseMessage && (
                        <p className="successMessage">
                            {responseMessage}
                        </p>
                    )}

                    {errorMessage && (
                        <p className="errorMessage">
                            {errorMessage}
                        </p>
                    )}

                    <div className="links">
                        <a
                            href="https://www.facebook.com/prawjal.kulung/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={facebookIcon}
                                alt="Facebook"
                                className="link"
                            />
                        </a>

                        <a
                            href="https://www.linkedin.com/in/ninamhang-kulung-5a5805279/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={LinkedInIcon}
                                alt="LinkedIn"
                                className="link"
                            />
                        </a>

                        <a
                            href="https://github.com/hang-kulung"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={githubIcon}
                                alt="Github"
                                className="link"
                            />
                        </a>

                        <a
                            href="https://www.instagram.com/ninam_hang21/?hl=en"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={instagramIcon}
                                alt="Instagram"
                                className="link"
                            />
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Contact;